import platform from 'components/Trackers/platform'
import { useTracking } from 'utils/analytics/useTracking'

export const useEditAddressTracking = () => {
  const track = useTracking(screenViewed)

  return {
    ctaTapped: (cta_title: string) =>
      track.buttonTapped({
        ...ctaTapped,
        cta_title,
      }),
  }
}

const sharedProps = {
  platform,
  card_type: 'moc',
  context: 'registration',
  screen: 'bankCardOrderEditAddressInput',
  screen_name: 'bankCardOrderEditAddressInput',
}

const screenViewed = {
  object: 'Screen',
  action: 'Viewed',
  object_name: 'bankCardOrderEditAddressInput',
  ...sharedProps,
}

const ctaTapped = {
  object: 'Button',
  action: 'Tapped',
  object_name: 'bankCardOrderEditAddressInputCTA',
  ...sharedProps,
}
